// extracted by mini-css-extract-plugin
export var resourceBody = "resource-module--resourceBody--D1Uog";
export var sbShowMain = "resource-module--sb-show-main--anGy-";